import { API_BASE_URL, API_HEADERS } from '../config';

const getAuthHeaders = (): Record<string, string> => {
  const token = sessionStorage.getItem('corvus_token');
  return {
    ...API_HEADERS,
    ...(token ? { Authorization: token } : {}),
  };
};

const parseUserEntry = (entry: unknown): string | undefined => {
  if (typeof entry === 'string') {
    const trimmed = entry.trim();
    return trimmed || undefined;
  }
  if (!entry || typeof entry !== 'object') return undefined;
  const rec = entry as Record<string, unknown>;
  const candidate = rec.user ?? rec.username ?? rec.usuario ?? rec.nick ?? rec.name ?? rec.handler;
  if (typeof candidate === 'string' && candidate.trim()) return candidate.trim();
  return undefined;
};

const parseUsersPayload = (payload: unknown): string[] => {
  if (!payload) return [];
  if (Array.isArray(payload)) {
    return payload.map(parseUserEntry).filter((u): u is string => Boolean(u));
  }
  if (typeof payload !== 'object') return [];
  const rec = payload as Record<string, unknown>;
  const nested = rec.usuarios ?? rec.users ?? rec.miembros ?? rec.members ?? rec.data;
  if (nested !== undefined && nested !== payload) {
    return parseUsersPayload(nested);
  }
  return [];
};

const fetchUsersFromUrl = async (url: string): Promise<string[]> => {
  const response = await fetch(url, { headers: getAuthHeaders() });
  if (!response.ok) return [];
  const json = await response.json();
  let all = parseUsersPayload(json);

  const totalPages = Number(json?.pagination?.totalPages || 0);
  if (totalPages <= 1) return all;

  for (let page = 2; page <= totalPages; page += 1) {
    const separator = url.includes('?') ? '&' : '?';
    const pageUrl = `${url}${separator}page=${page}`;
    const pageRes = await fetch(pageUrl, { headers: getAuthHeaders() });
    if (!pageRes.ok) break;
    const pageJson = await pageRes.json();
    all = all.concat(parseUsersPayload(pageJson));
  }
  return all;
};

const USER_LIST_PATHS = [
  '/flota/usuarios?limit=500',
  '/flota/usuarios?all=true',
  '/flota/usuarios',
  '/flota/users?limit=500',
  '/flota/users',
  '/organizacion/usuarios',
  '/organizaciones/usuarios',
];

export const fleetService = {
  async getOrganizationUsers(): Promise<string[]> {
    for (const path of USER_LIST_PATHS) {
      try {
        const users = await fetchUsersFromUrl(`${API_BASE_URL}${path}`);
        if (users.length > 0) {
          return Array.from(new Set(users)).sort((a, b) => a.localeCompare(b, 'es'));
        }
      } catch {
        // Probar siguiente ruta
      }
    }
    return [];
  },
};
